import type { LayoutType } from 'types';
import type { TemplateFormsState } from '../index';

interface Payload {
  layoutType: LayoutType;
  fromIndex: number;
  toIndex: number;
}

export const reorderTab = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { layoutType, fromIndex, toIndex } = payload;
  const tabs = state[layoutType].tabs;
  if (fromIndex < 0 || fromIndex >= tabs.length || toIndex < 0 || toIndex >= tabs.length || fromIndex === toIndex) return;

  const [moved] = tabs.splice(fromIndex, 1);
  tabs.splice(toIndex, 0, moved);
  tabs.forEach((tab, index) => {
    tab.order = index;
  });
};
